import Vue from 'vue'
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/de'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(DatePicker)
